import { useEffect, useState } from "react";
import { IMAGES } from "../../../../assets";
import { useInView } from "react-intersection-observer";

const EaseOfSearch = () => {
  const [leftTextRef, inLeftTextView] = useInView({
		triggerOnce: true, // Trigger animation only once
		threshold: 0.3, // Trigger when 10% of the image is visible
	});
  const [leftImgRef, inLeftImgView] = useInView({
		triggerOnce: true, // Trigger animation only once
		threshold: 0.3, // Trigger when 10% of the image is visible
	});
  const [rightTextRef, inRightTextView] = useInView({
		triggerOnce: true, // Trigger animation only once
		threshold: 0.3, // Trigger when 10% of the image is visible
	});
  const [rightImgRef, inRightImgView] = useInView({
		triggerOnce: true, // Trigger animation only once
		threshold: 0.3, // Trigger when 10% of the image is visible
	});
  return (
    <section className="search-section">
      <div className="container">
        <div className="row">
          <div ref={leftTextRef} className={`col-lg-6 col-md-6 col-sm-12 col-12 ${inLeftTextView ? 'animate__animated animate__slideInUp' : ''}`}>
            <div className="search_content" data-aos="fade-up">
              <figure className="search-icon">
                <img src={IMAGES.coslultation} alt="" className="img-fluid" />
              </figure>
              <h2>On-Demand Real-Time Consultation</h2>
              <p>
                Get instant clarity when you need it most. With our on-demand real-time consultation, connect with expert astrologers anytime— no waiting, no appointments. Whether it’s love, career, or life’s big questions, guidance is just a tap away!
              </p>
            </div>
          </div>
          <div ref={rightImgRef} className={`col-lg-6 col-md-6 col-sm-12 col-12 ${inRightImgView ? 'animate__animated animate__slideInRight' : ''}`}>
            <div className="search_wrapper">
              <figure className="mb-0 search-sidecircle">
                <img
                  className="img-fluid"
                  src={IMAGES.search_sidecircle}
                  alt=""
                />
              </figure>
              <figure className="mb-0 search-phoneback">
                <img src={IMAGES.search_phoneback} alt="" />
              </figure>
              <figure className="mb-0 search-phone1">
                <img className="img-fluid" src={IMAGES.search_phone1} alt="" />
              </figure>
              <figure className="mb-0 search-phone2">
                <img className="img-fluid" src={IMAGES.search_phone2} alt="" />
              </figure>
            </div>
          </div>
        </div>
        {/* <!-- Manage --> */}

        <div className="manage-section">
          <div className="row">
            <div ref={leftImgRef} className={`col-lg-6 col-md-6 col-sm-12 col-12 order-md-1 order-2 ${inLeftImgView ? 'animate__animated animate__slideInLeft' : ''}`}>
              <div className="manage_wrapper">
                <figure className="mb-0 manage-sidecircle">
                  <img
                    className="img-fluid"
                    src={IMAGES.manage_sidecircle}
                    alt=""
                  />
                </figure>
                <figure className="mb-0 manage-phoneback">
                  <img src={IMAGES.manage_phoneback} alt="" />
                </figure>
                <figure className="mb-0 manage-phone2">
                  <img
                    className="img-fluid"
                    src={IMAGES.search_phone3}
                    alt=""
                  />
                </figure>
                <figure className="mb-0 manage-phone1">
                  <img
                    className="img-fluid"
                    src={IMAGES.search_phone4}
                    alt=""
                  />
                </figure>
              </div>
            </div>
            <div ref={rightTextRef} className={`col-lg-6 col-md-6 col-sm-12 col-12 order-md-2 order-1 ${inRightTextView ? 'animate__animated animate__slideInUp' : ''}`}>
              <div className="manage_content" data-aos="fade-up">
                <figure className="search-icon manage-icon">
                  <img src={IMAGES.horoscope} alt="" className="img-fluid" />
                </figure>
                <h2>Join as an Astrologer</h2>
                <p>
                 Share your cosmic wisdom with the world. Join our platform as a certified astrologer and connect with seekers through chat and calls. Expand your reach, grow your practice, and help others find clarity one chart at a time.
                </p>
                {/* <p className="p-text">
                  Assumenda est, omnis dolor repellendus temoriu autem quibusdam
                  et aut officiis repudiandae sint molestiae non recusandae.{" "}
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EaseOfSearch;
